import EditorDuck from '@aytm/app/insights/dashboard/duckness/ducks/EditorDuck/EditorDuck'
import { EDITOR_ACTIONS } from '@aytm/app/insights/dashboard/duckness/ducks/EditorDuck/EditorDuck.actions'
import type { DuckActionPayloadTuple } from '@aytm/app/insights/dashboard/duckness/poolDispatch'

export const makeUpdateEditorAction = (updateEditorEvent: unknown) =>
  [EditorDuck.duckName, EDITOR_ACTIONS.UPDATE, updateEditorEvent] as DuckActionPayloadTuple<unknown>

export const makeImageUploadEditorAction = (imageUploadEvent: unknown) =>
  [EditorDuck.duckName, EDITOR_ACTIONS.IMAGE_UPLOAD, imageUploadEvent] as DuckActionPayloadTuple<unknown>
